<style lang="less">
    .k-dlg__inner {
        bottom: 1rem;
    }

    .msg-bar,
    .result-bar,
    .slider-bar {
        width: 95%;
        margin: 0 auto;
    }

    .dlg-btns {
        text-align: center;
        padding: 0 0 .3rem;
    }

    /* .dlg-btns .van-button {
    width: 1.98rem;
} */

    .msg-bar {
        padding: .2rem 0;
        color: #FFC15E;
    }

    .result-bar {
        padding: 0 0 .3rem;
    }

    .result-num {
        font-size: .56rem;
        color: #FDED66;
    }

    .k-dlg__inner .cl_flat {
        color: #FDED66;
    }

    .result-num .num_unit,
    .result-num .rate_per {
        font-size: .36rem;
    }

    /* .slider-bar.up .van-slider__bar {
    background: #f00;
}
.slider-bar.down .van-slider__bar {
    background: #090;
} */
    .slider-bar {
        padding: .3rem 0 .3rem;
    }

    .slider-bar .van-slider__bar {
        background: #FDB141;
    }

    .slider-bar .van-slider__button {
        width: .40rem;
        height: .40rem;
    }

    .rate-bar {
        position: relative;
        top: 0;
        left: 0;
        padding: .1rem 0 0;
        line-height: .4rem;
        text-align: center;
    }

    .rate-bar__max,
    .rate-bar__min {
        position: absolute;
        top: .1rem;
    }

    .rate-bar__min {
        left: 0;
    }

    .rate-bar__max {
        right: 0;
    }

    .stepper-bar {
        width: 80%;
        margin: 0 auto;
        text-align: center;
        padding: .4rem 0 .4rem 0;
    }

    .stepper-bar .van-stepper__input {
        width: 2rem;
        background: #764F10;
        border-color: #DB9535;
        color: #fff;
        height: .72rem;
        font-size: .32rem;
        box-sizing: border-box;
    }

    .stepper-bar .van-stepper__minus,
    .stepper-bar .van-stepper__plus {
        width: 1rem;
        background: #DB9535;
        border-color: #DB9535;
        color: #fff;
        height: .72rem;
        box-sizing: border-box;
        /* border-radius: 4px; */
    }

    .stepper-bar .van-stepper__input::after {
        display: inline-block;
        contain: '%';
    }

    .stepper-bar .van-stepper__minus::before,
    .stepper-bar .van-stepper__plus::before,
    .stepper-bar .van-stepper__minus::after,
    .stepper-bar .van-stepper__plus::after {
        background: #fff;
    }

    .stepper-bar .van-stepper__minus::before,
    .stepper-bar .van-stepper__plus::before {
        width: 16px;
        height: 2px;
    }

    .stepper-bar .van-stepper__minus::after,
    .stepper-bar .van-stepper__plus::after {
        height: 16px;
        width: 2px;
    }

    .dlg-btn {
        display: inline-block;
        text-decoration: none;
        width: 1.96rem;
        height: 0.8rem;
        line-height: 0.74rem;
        font-size: 0.36rem;
        background-size: auto 100%;
        margin: 0 .3rem;
    }

    .dlg-btn span {
        visibility: hidden;
    }

    .dlg-btn--submit {
        background-image: url("../../../../assets/img/reality/play/btn_tijiao_1.png");
    }

    .dlg-btn--cancel {
        background-image: url("../../../../assets/img/reality/play/btn_think_1.png");
    }

</style>

<template>
    <div class="k-dlg-wrap" v-if="show">
        <div class=" k-dlg__inner">
            <div class="k-dlg__head">
                <div class="k-dlg__title">
                    <h4>预测股价</h4>
                </div>
                <div></div>
                <a class="k-dlg__close" @click="close"><span>关闭</span></a>
            </div>
            <div class="k-dlg__body">
                <div class="msg-bar">
                    <dl>
                        <dd>1.拖动滑块，选择你预测的幅度，确定提交后不可修改。</dd>
                        <dd>2.{{finalRes|time2text}}会公布成绩，成绩公布后在该页面可以看到结果。</dd>
                        <!-- <dd>cupId:{{cupId}} gameId:{{gameId}} kid:{{kid}}</dd> -->
                    </dl>
                </div>
                <div class="slider-bar" :class="guessColor">
                    <van-slider v-model="sliderValue" :min="0" :max="100" bar-height="6px" :step="1" />
                    <div class="rate-bar">
                        <div class="rate-bar__rate rate-bar__min">
                            <k-num-rate :value="minRate" /><br>{{minPrice}}元
                        </div>
                        <div class="rate-bar__rate rate-bar__zero">
                            <k-num-rate :value="0" /><br>{{closePrice}}元
                        </div>
                        <div class="rate-bar__rate rate-bar__max">
                            <k-num-rate :value="maxRate" /><br>{{maxPrice}}元
                        </div>
                    </div>
                </div>
                <div v-if="predictRange" class="stepper-bar">
                    <van-stepper v-model="stepperValue" :min="stepperMin" :max="stepperMax" :step="stepperStep" />
                </div>
                <div class="result-bar">
                    您猜涨跌幅为
                    <span class="result-num">
                        <k-num-rate :value="chgRate" />&nbsp;
                        <k-num-money :value="chgPrice" :sign="true" /></span>
                </div>

                <div class="dlg-btns">
                    <a class="dlg-btn dlg-btn--cancel" href="javascript:;" @click="close"><span>我再想想</span></a>

                    <a class="dlg-btn dlg-btn--submit" href="javascript:;" @click="submit"><span>确认提交</span></a>
                </div>
                <div class="k-dlg__foot">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex'
    export default {
        name: 'dlg-play',
        data() {
            return {
                stepperValue: 0, // 价格
                sliderValue: 50
            }
        },
        props: ['show', 'cupId', 'gameId', 'kid', 'today'],
        computed: {
            ...mapGetters(['fixNumber', 'finalRes']),
            ...mapGetters('reality', ['waitPlayKids', 'isValidKid', 'isPlayedKid', 'predictRange']),
            closePrice() { // 单位分
                return this.today ? this.today.close : 0
            },
            maxPrice() { // 单位：分
                return this.rangeValue('maxPrice')
            },
            minPrice() { // 单位：分
                return this.rangeValue('minPrice')
            },
            offsetPrice() {
                return this.fixNumber(this.maxPrice - this.minPrice, 2)
            },
            curPrice() {
                return Math.round(this.closePrice + this.stepperValue)
            },
            stepperMax() {
                return this.maxPrice
            },
            stepperMin() {
                return this.minPrice
            },
            stepperStep() {
                const {offsetPrice} = this
                return offsetPrice > 10 ? Math.min(this.fixNumber(offsetPrice/1000, 2), 0.01) : 0.01
            },
            maxRate() {
                return this.rangeValue('maxRate')
            },
            minRate() {
                return this.rangeValue('minRate')
            },
            chgPrice() {
                return this.fixNumber(this.stepperValue - this.closePrice, 2)
            },
            chgRate() {
                const {stepperValue, closePrice} = this
                return closePrice > 0 ? this.fixNumber((stepperValue - closePrice) / closePrice, 4) : 0
            },
            guessColor() {
                const {
                    closePrice,
                    stepperValue
                } = this
                return stepperValue > closePrice ? 'up' : stepperValue < closePrice ? 'down' : 'flat'
            }
        },
        watch: {
            stepperValue(value) {
                const { offsetPrice, minPrice} = this
                const per = offsetPrice > 0 ? Math.round((value - minPrice) * 100 / offsetPrice) : 0
                // console.log({offsetPrice, minPrice, closePrice, value, per});
                this.sliderValue = per
            },
            sliderValue(value) {
                const {
                    offsetPrice,
                    minPrice
                } = this
                const curPrice = this.fixNumber(offsetPrice * value / 100 + minPrice, 2 )
                // console.log({value, curPrice});

                this.stepperValue = curPrice
                // console.log(offsetPrice);
                // const rate = value > 50 ? max * offset : -offset * min
                // this.stepperValue = fixNumber(rate, 2)
            },
            closePrice(n) {
                this.stepperValue = this.fixNumber(n, 2)
            }
        },
        methods: {
            ...mapActions('reality', ['submitAction']),
            rangeValue(key) {
                const range = this.predictRange
                return range ? +range[key] : 0
            },
            close() {
                this.$emit('close')
            },
            async submit() {
                const {
                    cupId,
                    gameId,
                    kid,
                    chgRate,
                    stepperValue
                } = this
                await this.submitAction({
                    cupId,
                    gameId,
                    kid,
                    predictVal: stepperValue,
                    predictPer: chgRate
                })
                this.close()
                this.$emit('submitted')
            }
        },
        created() {
            this.stepperValue = this.closePrice
        }
    };

</script>
